/** `failQueuedRunsForOrg`'s fixed reason string (server/src/db/data.ts) —
 *  posted as a queued run's `errorMessage` when a Fleet rental fails/times
 *  out while that run was waiting for the org's instance to come `ready`
 *  (`instanceProvisioner.ts`'s `pollToReady`). Exported here (rather than
 *  left as a private server-side const) so the frontend can recognize this
 *  specific failure — `RunDetail.status === 'failed' && RunDetail.errorMessage
 *  === PROVISION_FAILED_REASON` — and offer a retry CTA instead of just the
 *  generic failed-run treatment. */
export const PROVISION_FAILED_REASON = 'instanța nu a pornit';
